import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getCriticalStock = async (params) => {
	const { data } = await axios.get(`${API}/client/inventories/critical-stock`, {
		params,
	});
	return data;
};

export const saveCriticalStock = async (params) => {
	const { data } = await axios.post(`${API}/client/inventories/critical-stock-save`, params);
	return data;
};
